if (!window.EcoScentPlacesCategories) {
  window.EcoScentPlacesCategories = {
    sectionSelector: '.places-categories-section',
    activeButtonClass: 'places-categories-nav-button--active',

    updateNavOverflow: function (nav, navList) {
      if (!nav || !navList) return;
      navList.classList.toggle('places-categories-nav-list--scrollable', navList.scrollWidth > nav.clientWidth);
    },

    setActiveButton: function (section, activeButton) {
      const namespace = window.EcoScentPlacesCategories;
      section.querySelectorAll('[data-places-categories-nav-button]').forEach(function (button) {
        button.classList.remove(namespace.activeButtonClass);
      });
      activeButton.classList.add(namespace.activeButtonClass);
    },

    observeBlocks: function (section, blocks) {
      const namespace = window.EcoScentPlacesCategories;
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const blockId = entry.target.dataset.placesCategoriesBlock;
          const button = section.querySelector('[data-places-categories-nav-button="' + blockId + '"]');
          if (button) namespace.setActiveButton(section, button);
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

      blocks.forEach(function (block) { observer.observe(block); });
    },

    initSection: function (section) {
      const namespace = window.EcoScentPlacesCategories;
      if (section.dataset.placesCategoriesReady === 'true') return;
      section.dataset.placesCategoriesReady = 'true';

      const nav = section.querySelector('.places-categories-nav');
      const navList = section.querySelector('.places-categories-nav-list');
      const updateOverflow = function () {
        namespace.updateNavOverflow(nav, navList);
      };

      updateOverflow();
      window.addEventListener('resize', updateOverflow);

      const navButtons = section.querySelectorAll('[data-places-categories-nav-button]');
      const blocks = section.querySelectorAll('[data-places-categories-block]');
      if (!navButtons.length || !blocks.length) return;

      navButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          const target = section.querySelector('[data-places-categories-block="' + button.dataset.placesCategoriesNavButton + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          namespace.setActiveButton(section, button);
        });
      });

      namespace.observeBlocks(section, blocks);
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentPlacesCategories;
      (root || document).querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentPlacesCategories.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentPlacesCategories;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { namespace.initAllSections(); });
      } else {
        namespace.initAllSections();
      }
      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentPlacesCategories.listen();
}
